'use client'

export function GlobalNav() {

  return (
    <div className="bg-black px-8 py-[2px]">
      <a
        className="text-xs text-white inline-block"
        href="https://www.canadagoose.jp/"
        target="_blank"
        rel="noopener noreferrer"
      >
        カナダグース日本公式サイト
      </a>
      <a
        className="text-xs text-white underline underline-offset-2 inline-block ml-2"
        href="https://generations.canadagoose.jp/"
        target="_blank"
        rel="noopener noreferrer"
      >
        CANADA GOOSE Generations
      </a>
    </div>
  )
}
